import {
  Build,
  BuildOutlined,
  Category,
  CategoryOutlined,
  ContentPasteGoOutlined,
  Explore,
  ExploreOutlined,
  Home,
  HomeOutlined,
  LocalOffer,
  LocalOfferOutlined,
  Settings,
  SettingsOutlined,
  TouchApp,
  TouchAppOutlined,
  Work,
  WorkOutline,
} from "@mui/icons-material";
import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { AuthContext } from "../../context/auth-context";
import { DiscoveryContext as BrandAuditDiscoveryContext } from "../../luminaire/BrandAudit/discovery-context";
import { DiscoveryContext as DiscoveryContextV2 } from "../../luminaire/DiscoveryV2/discovery-context";
import { DiscoveryContext } from "../../luminaire/Discovery/discovery-context";
import styles from "./Sidebar.module.css";
import { ENTITY_LABELS } from "../../utils/labelMapping";

const navItems = [
  { target: "home", label: "Home", icon: Home, iconOutlined: HomeOutlined },
  {
    target: "prompt-engine",
    label: "LLM Insights",
    icon: Build,
    iconOutlined: BuildOutlined,
  },
  // {
  //   target: "discovery",
  //   label: "Discovery",
  //   icon: Explore,
  //   iconOutlined: ExploreOutlined,
  // },
  {
    target: "discoveryV2",
    label: "Discovery",
    icon: Explore,
    iconOutlined: ExploreOutlined,
  },
  {
    target: "brand-audit",
    label: `${ENTITY_LABELS.Brand} and ${ENTITY_LABELS.Product} Audit`,
    icon: Work,
    iconOutlined: WorkOutline,
  },
  {
    target: "brand-monitoring",
    label: `${ENTITY_LABELS.Brand} and ${ENTITY_LABELS.Product} Analysis and Monitoring`,
    icon: LocalOffer,
    iconOutlined: LocalOfferOutlined,
  },
  // {
  //   target: "product-monitoring",
  //   label: `${ENTITY_LABELS.Product} Analysis and Monitoring`,
  //   icon: Work,
  //   iconOutlined: WorkOutline,
  // },
  // {
  //   target: "category-discovery",
  //   label: "Category Discovery",
  //   icon: Category,
  //   iconOutlined: CategoryOutlined,
  // },
  {
    target: "actions",
    label: "Actions",
    icon: TouchApp,
    iconOutlined: TouchAppOutlined,
  },

  {
    target: "conversations",
    label: "Conversations",
    icon: ContentPasteGoOutlined,
    iconOutlined: ContentPasteGoOutlined,
  },

  {
    target: "metric-content",
    label: "Content Mapping",
    icon: ContentPasteGoOutlined,
    iconOutlined: ContentPasteGoOutlined,
  },
  {
    target: "llm-reporting",
    label: "Reporting",
    icon: ContentPasteGoOutlined,
    iconOutlined: ContentPasteGoOutlined,
  },
  // {
  //   target: "buying-journey",
  //   label: "Metric Content Mapping",
  //   icon: ContentPasteGoOutlined,
  //   iconOutlined: ContentPasteGoOutlined,
  // },
  // {
  //   target: "purchase-funnel",
  //   label: "Playground",
  //   icon: ContentPasteGoOutlined,
  //   iconOutlined: ContentPasteGoOutlined,
  // },

  // The "Settings" NavLink will be added conditionally
];

const Sidebar = () => {
  const { user } = useContext(AuthContext);
  const discoveryCtx = useContext(DiscoveryContext);
  const discoveryCtxV2 = useContext(DiscoveryContextV2);
  const brandAuditDiscoveryContext = useContext(BrandAuditDiscoveryContext);
  const customer_id = user && user?.customer_id
  const isAdmin =
    user?.user_role?.role?.name == "Company admin" ||
    user?.user_role?.role?.name == "Super User";



  return (
    <ul className="nav nav-pills p-3 flex-column mb-auto">
      {navItems.map(
        ({ target, label, icon: Icon, iconOutlined: IconOutlined }) => (
          <li className={styles.navItem} key={target}>
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? `${styles.navLink} ${styles.navLinkActive}`
                  : styles.navLink
              }
              onClick={() => {
                console.log("target", target);
                if (target === "discovery") {
                  discoveryCtx.updateType("brand");
                }
                if (target === "discoveryV2") {
                  discoveryCtxV2.updateType("brand");
                }
                if (target === "brand-audit") {
                  console.log("setting", target);
                  brandAuditDiscoveryContext.updateType("brand");
                }
                discoveryCtx.updateLanguage("en");
                discoveryCtxV2.updateLanguage("en");
                discoveryCtx.resetState();
                discoveryCtxV2.resetState();
                discoveryCtxV2.resetFormState(true);
                brandAuditDiscoveryContext.resetState();
                brandAuditDiscoveryContext.resetFormState(true);
              }}
              to={target}
            >
              {({ isActive }) => (
                <React.Fragment>
                  <span
                    className={`${styles.iconWrap} ${isActive ? styles.iconWrapActive : ""
                      }`}
                  >
                    {isActive ? (
                      <Icon className={`${styles.activeIcon}`} />
                    ) : (
                      <IconOutlined className={`${styles.icon}`} />
                    )}
                  </span>
                  <span className={`${styles.labelText}`}>{label}</span>
                </React.Fragment>
              )}
            </NavLink>
          </li>
        )
      )}

      {/* Conditionally render the "Settings" NavLink for admin users */}
      {isAdmin && (
        <li className={styles.navItem} key="settings">
          <NavLink
            className={({ isActive }) =>
              isActive
                ? `${styles.navLink} ${styles.navLinkActive}`
                : styles.navLink
            }
            to="settings"
          >
            {({ isActive }) => (
              <React.Fragment>
                <span
                  className={`${styles.iconWrap} ${isActive ? styles.iconWrapActive : ""
                    }`}
                >
                  {isActive ? (
                    <Settings className={`${styles.activeIcon}`} />
                  ) : (
                    <SettingsOutlined className={`${styles.icon}`} />
                  )}
                </span>
                <span className={`${styles.labelText}`}>Settings</span>
              </React.Fragment>
            )}
          </NavLink>
        </li>
      )}

        <li className={styles.navItem} key="set">
          <NavLink
            className={({ isActive }) =>
              isActive
                ? `${styles.navLink} ${styles.navLinkActive}`
                : styles.navLink
            }
            to="templateSetting"
          >
            {({ isActive }) => (
              <React.Fragment>
                <span
                  className={`${styles.iconWrap} ${isActive ? styles.iconWrapActive : ""
                    }`}
                >
                  {isActive ? (
                    <Settings className={`${styles.activeIcon}`} />
                  ) : (
                    <SettingsOutlined className={`${styles.icon}`} />
                  )}
                </span>
                <span className={`${styles.labelText}`}>Template Settings</span>
              </React.Fragment>
            )}
          </NavLink>
        </li>
    </ul>
  );
};

export default Sidebar;
